import { BulkActionsApplicableAction } from "components/BulkActions/ChooseActionStep/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsItems from "components/BulkActions/Drawer/ActionSteps/Items";
import {
  BulkActionItemID,
  BulkActionsActionsPerItem,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsPatternsActionsList from "components/BulkActionsPatterns/ActionsList";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import AiIntegrationsBulkActionsSelectedItem from "./SelectedIntegrationItem";
import { AiIntegrationsBulkActions } from "./types";

type AiIntegrationsBulkActionsSelectedItemsViewProps = {
  items: AiIntegrationView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  availableActions: Array<BulkActionsApplicableAction<AiIntegrationsBulkActions>>;
  actionsPerItem: BulkActionsActionsPerItem<AiIntegrationsBulkActions>;
  onEmptyActionsCancel: () => void;
};

const AiIntegrationsBulkActionsSelectedItemsView = ({
  items,
  onItemDismiss,
  actionsPerItem,
  availableActions,
  onEmptyActionsCancel,
}: AiIntegrationsBulkActionsSelectedItemsViewProps) => {
  return (
    <>
      <BulkActionsDrawerActionStepsItems selectedItemsCount={items.length}>
        {items.map((item) => (
          <AiIntegrationsBulkActionsSelectedItem
            key={item.id}
            item={item}
            onDismiss={onItemDismiss}
            itemActions={actionsPerItem.get(item.id)}
            allActionsQty={availableActions.length}
            step={BulkActionsStep.ChooseAction}
          />
        ))}
      </BulkActionsDrawerActionStepsItems>

      <BulkActionsDrawerActionStepsFooter>
        <BulkActionsPatternsActionsList
          variant={BulkActionsVariant.Drawer}
          availableActions={availableActions}
          onEmptyActionsCancel={onEmptyActionsCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default AiIntegrationsBulkActionsSelectedItemsView;
